import classNames from 'classnames';
import { PartialWidthContainer, PropertyBlock, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useTenancies } from 'state';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import styles from './TenanciesPastScreen.module.scss';

/**
 * TenanciesListScreen
 *
 * @return {JSX.Element}
 */
const TenanciesPastScreen = ({ className }) => {
  const navigate = useNavigate();
  const { pastTenancies } = useTenancies();
  const handleTenancyClick = useCallback(
    (id) => () => navigate(`../view/${id}`),
    [navigate]
  );

  return (
    <PartialWidthContainer
      className={classNames(
        styles.PropertiesListScreen,
        className,
        `${TenanciesPastScreen.displayName}`
      )}
      column
      gap
      flex
      small
    >
      <Helmet title="Past Tenancies" />
      <Txt xxx>Past tenancies</Txt>
      {!pastTenancies?.length ? (
        pastTenancies.map((tenancyState) => {
          const tenancyData = tenancyState.data;
          const propertyData = tenancyState.property?.data;

          console.log(tenancyData, propertyData);

          return (
            <PropertyBlock
              onClick={handleTenancyClick(tenancyState.id)}
              key={tenancyState.id}
              imageUrls={propertyData.imageUrls}
              tenants={tenancyData.tenantCount}
              bathroomCount={propertyData.bathroomCount}
              bedroomCount={propertyData.bedroomCount}
              deposit={tenancyData.payments.rentAmount}
              postcode={propertyData.address.name}
              startDate={fromSwiftDate(tenancyData.dates.startDate)}
              endDate={fromSwiftDate(tenancyData.dates.endDate)}
            />
          );
        })
      ) : (
        <Txt>No past tenancies</Txt>
      )}
    </PartialWidthContainer>
  );
};

TenanciesPastScreen.displayName = 'TenanciesListScreen';

export default observer(TenanciesPastScreen);
